import { render, staticRenderFns } from "./play-rounded.vue?vue&type=template&id=bface40a"
import script from "./play-rounded.vue?vue&type=script&lang=js"
export * from "./play-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports